import type { IMosaicTocExpanded } from "./interface";

/**
 * Blocks ToC updates while a linked TLF patch is in progress.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state with patching protection enabled.
 */
export const toc_savingTocItemViaTlf = (state: IMosaicTocExpanded): IMosaicTocExpanded => ({
  ...state,
  blocked: "patching",
});
